export default function TodayClassCard({ entry, staffLookup, color, blockColor = "", index, groupLabelByKey = {} }) {
  const lead = staffLookup[entry?.lead_staff_id] || "";
  const supports = (entry?.support_staff_ids || []).map(id => staffLookup[id]).filter(Boolean);
  const isHighlighted = !!entry.highlight;
  const groupLabel = (entry.student_group_key && groupLabelByKey[entry.student_group_key]) || entry.student_group || "";
  const leftColor = blockColor || color.accent;

  return (
    <div className={`rounded-lg p-4 ${index > 0 ? "mt-3" : ""}`}
      style={{ background: isHighlighted ? "#FEF3C7" : leftColor + "0D", border: `1.5px solid ${isHighlighted ? "#F59E0B" : leftColor + "30"}`, borderLeft: isHighlighted ? "5px solid #F59E0B" : `5px solid ${leftColor}` }}
      data-testid={`today-class-${index}`}>
      <p className="font-bold text-xl" style={{ color: isHighlighted ? "#92400E" : color.accent }}>{entry.subject || "—"}</p>
      {lead && <p className="text-base text-gray-700 mt-1"><span className="font-medium">Lead:</span> {lead}</p>}
      {supports.length > 0 && <p className="text-base text-gray-600"><span className="font-medium">Support:</span> {supports.join(", ")}</p>}
      {groupLabel && <p className="text-base text-gray-500 italic">{groupLabel}</p>}
      {entry.location && <p className="text-sm text-gray-400">{entry.location}</p>}
    </div>
  );
}
